import { render, staticRenderFns } from "./ProgramSection.vue?vue&type=template&id=e09ec13c&scoped=true"
import script from "./ProgramSection.vue?vue&type=script&lang=js"
export * from "./ProgramSection.vue?vue&type=script&lang=js"
import style0 from "./ProgramSection.vue?vue&type=style&index=0&id=e09ec13c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e09ec13c",
  null
  
)

export default component.exports